const append = ({ data, loadingState, oldData, draft }) => {
  const result = { ...oldData, loading: false };

  if (Array.isArray(oldData?.items)) {
    result.items = [...oldData.items, data];
    result.totalItems = (oldData.totalItems || 0) + 1;
  }

  if (Array.isArray(oldData?.data)) {
    result.data = [...oldData.data, data];
    result.totalItems = (oldData.totalItems || 0) + 1;
  }

  if (!draft?.items && !draft?.data && Array.isArray(oldData)) {
    return [...oldData, data];
  }

  return result;
};

export default append;
